import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import Navigation from "./routes/navigation";
import SideBar from "./components/sidebar";
import Header from "./components/header";

const App = () => {
  const [pathName, setPathName] = useState("");
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/");
    setPathName(path[1]);
  }, [location]);

  return (
    <div className="d-flex flex-row">
      {pathName !== "auth" ? <SideBar /> : null}
      <div className="d-flex flex-column">
        {pathName !== "auth" ? <Header /> : null}
        <div className={`scroll-container`}>
          <Navigation />
        </div>
      </div>
    </div>
  );
};

export default App;
